import { render, staticRenderFns } from "./ChainTableOverlay.vue?vue&type=template&id=dc267510"
import script from "./ChainTableOverlay.vue?vue&type=script&lang=js"
export * from "./ChainTableOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports